const arrowLeft = "data:image/svg+xml,%3csvg%20width='7'%20height='12'%20viewBox='0%200%207%2012'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M2.49171%206.00004L6.7459%2010.2542L5.92094%2011.0792L0.841797%206.00004L5.92094%200.920898L6.7459%201.74586L2.49171%206.00004Z'%20fill='%2397A1AB'/%3e%3c/svg%3e";
export {
  arrowLeft as default
};
//# sourceMappingURL=arrow-left.svg.es.js.map
